import React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import Select from 'react-select'

import ListLoader from '../../../Shared/ListLoader'

import EntryBox from './EntryBox'

class EntriesContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      reloadFetch: false,
      entries: [],
      meta: [],
    }

    this.onFetchEntriesSuccess = this.onFetchEntriesSuccess.bind(this)
    this.onFilterChange = this.onFilterChange.bind(this)
    this.onSortChange = this.onSortChange.bind(this)
    this.onPageChange = this.onPageChange.bind(this)
  }

  componentDidMount() {
    this.cancelSource = axios.CancelToken.source()

    this.fetchEntries()
  }

  componentWillUnmount() {
    this.cancelSource.cancel()
  }

  fetchEntries() {
    const filters = this.activeFilters()

    axios.get(`/api/internal/${this.props.competitionSlug}/competition-submissions`,
      { cancelToken: this.cancelSource.token, params: filters })
      .then(this.onFetchEntriesSuccess)
      .catch((error) => {})
  }

  onFetchEntriesSuccess(response) {
    this.setState(prevState => ({
      reloadFetch: false,
      entries: this.state.reloadFetch ? response.data.data : prevState.entries.concat(response.data.data),
      meta: response.data.meta,
    }))

    this.updateGalleryDetails(response.data.data)
  }

  activeFilters() {
    return {
      category: this.state.meta.category,
      sort_by: this.state.meta.sortBy,
      page: this.state.meta.currentPage,
    };
  }

  updateGalleryDetails(data) {
    const order = this.props.galleryOrder
    const slugs = this.props.gallerySlugs

    order.splice(0, order.length)
    slugs.splice(0, slugs.length)

    data.map((entry) => {
      order.push(entry.id)
      slugs.push(entry.attributes.slug)
    })
  }

  onFilterChange(data) {
    const newState = this.state
    newState.meta.category = data.value
    newState.meta.currentPage = 1
    newState.reloadFetch = true

    this.setState(newState)

    this.fetchEntries()
  }

  onSortChange(data) {
    const newState = this.state
    newState.meta.sortBy = data.value
    newState.meta.currentPage = 1
    newState.reloadFetch = true

    this.fetchEntries()
  }

  onPageChange(pageNumber) {
    const newState = this.state
    newState.meta.currentPage = pageNumber

    this.fetchEntries()
  }

  render() {
    const filterSelectOptions = I18n.t(`competition.${this.props.competitionSlug}.categories.category_filters`).map((category) => {
      return { value: category.slug, label: category.label }
    })

    filterSelectOptions.unshift({ value: null, label: 'All' })

    const sortSelectOptions = [
      { value: 'newest', label: 'Newest first' },
      { value: 'oldest', label: 'Oldest first' },
      { value: 'most_likes', label: 'Most likes first' },
    ]

    return (
      <section className="infinite-gallery">
        <header className="form-inline">
          <div className="form-group">
            <label htmlFor="gallery-filter">Filter:</label>
            <Select
              className="Select-new"
              id="gallery-filter"
              options={filterSelectOptions}
              onChange={this.onFilterChange}
              value={this.state.meta.category}
              searchable={false}
              clearable={false}
            />
          </div>
          <div className="form-group">
            <label htmlFor="gallery-sort">Sort:</label>
            <Select
              className="Select-new"
              id="gallery-sort"
              options={sortSelectOptions}
              onChange={this.onSortChange}
              value={this.state.meta.sortBy}
              searchable={false}
              clearable={false}
            />
          </div>
        </header>
        {
          this.state.entries.length === 0 ? (
            <div className="empty-content u-text-center">
              <p>
                Sorry, no entries yet
              </p>
            </div>
          ) : (
            <div>
              <div className="row infinite-gallery__list">
                {this.state.entries.map((entry) => (
                  <EntryBox
                    competitionSlug={this.props.competitionSlug}
                    path={`${this.props.competitionSlug}/gallery`}
                    id={entry.id}
                    entryName={entry.attributes.name}
                    entrySlug={entry.attributes.slug}
                    authorName={entry.attributes.authorName}
                    imageUrl={entry.attributes.primaryImage.url}
                    key={entry.id}
                  />
                ))}
              </div>
              <footer>
                <ListLoader
                  totalPages={this.state.meta.totalPages}
                  currentPage={this.state.meta.currentPage}
                  onShowMore={this.onPageChange}
                  buttonClass="btn btn-primary"
                />
              </footer>
            </div>
          )
        }
      </section>
    )
  }
}

EntriesContainer.propTypes = {
  competitionSlug: PropTypes.string.isRequired,
  galleryOrder: PropTypes.array.isRequired,
  gallerySlugs: PropTypes.array.isRequired,
}

export default EntriesContainer
